<div class="app-topstrip bg-dark text-white">

  <!-- LEFT SECTION -->
  <div class="left-section">

    <!-- Hamburger only when logged in -->
    @if (isLoggedIn) {
      <button mat-icon-button (click)="toggleSidenav.emit()">
        <mat-icon>menu</mat-icon>
      </button>
    }

    <!-- Branding Logo -->
    <a class="branding" (click)="navigateToHome()">
      <app-branding></app-branding>
    </a>

    <!-- Public Navigation (Only if not logged in) -->
    @if (!isLoggedIn) {
      <nav class="nav-links">
        <a routerLink="/home" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">Home</a>
        <a routerLink="/contact" class="nav-link">Contact Us</a>
        <a routerLink="/faq" class="nav-link">FAQ</a>
        <a routerLink="/about" class="nav-link">About Us</a>
        <a routerLink="/blog" class="nav-link">Blog</a>
      </nav>
    }
  </div>

  @if (isLoggedIn){
  <div class="topstrip-live-clock" aria-label="Current date and time">
    <span>{{ formattedHeaderDate }}</span>
    <strong>{{ formattedHeaderTime }}</strong>
  </div>
  }

  <!-- RIGHT SECTION -->
  <div class="right-section">

    <!-- Back to dashboard when logged in & on public page -->
    @if (isLoggedIn && isPublicPage) {
      <button mat-stroked-button color="accent" (click)="goBackToDashboard()">
        Back to Dashboard
      </button>
    }

    <!-- Logged in UI -->
    @if (isLoggedIn) {

      <!-- Theme mode -->
      <button
        mat-icon-button
        class="theme-mode-trigger"
        aria-label="Theme mode"
        [matMenuTriggerFor]="themeMenu"
        [matTooltip]="themeMode === 'dark' ? 'Night mode' : 'Light mode'"
      >
        <mat-icon>{{ themeMode === 'dark' ? 'dark_mode' : 'light_mode' }}</mat-icon>
      </button>

      <mat-menu #themeMenu="matMenu" class="theme-mode-menu-panel">
        <button mat-menu-item type="button" (click)="setThemeMode('light')">
          <mat-icon>light_mode</mat-icon>
          <span>Light mode</span>
          @if (themeMode === 'light') {
            <mat-icon class="theme-mode-check">check</mat-icon>
          }
        </button>
        <button mat-menu-item type="button" (click)="setThemeMode('dark')">
          <mat-icon>dark_mode</mat-icon>
          <span>Night mode</span>
          @if (themeMode === 'dark') {
            <mat-icon class="theme-mode-check">check</mat-icon>
          }
        </button>
      </mat-menu>

      <!-- Notifications -->
      <button
        mat-icon-button
        class="notification-trigger"
        aria-label="Notifications"
        [matMenuTriggerFor]="notificationMenu"
        [matBadge]="unreadCount || null"
        matBadgeColor="warn"
        matBadgeSize="small"
      >
        <mat-icon>notifications</mat-icon>
      </button>

<mat-menu
  #notificationMenu="matMenu"
  panelClass="notification-menu-panel"
  [class]="'notification-menu-panel'"
>
          <div class="notification-menu__header" (click)="$event.stopPropagation()">
          <div>
            <div class="notification-menu__title">Notifications</div>
            <div class="notification-menu__subtitle">{{ unreadCount }} unread</div>
          </div>
          <button
            mat-button
            color="primary"
            class="notification-menu__mark-all"
            type="button"
            [disabled]="!unreadCount"
            (click)="markAllNotificationsAsRead(); $event.stopPropagation()"
          >
            Mark all read
          </button>
        </div>

        @if (notifications.length) {
          <div class="notification-menu__list">
            @for (notification of notifications; track notification.id) {
              <button
                type="button"
                class="notification-item"
                [class.notification-item--unread]="!notification.read"
                (click)="openNotification(notification)"
              >
                <span class="notification-item__icon">
                  <mat-icon>{{ getNotificationIcon(notification.type) }}</mat-icon>
                </span>
                <span class="notification-item__content">
                  <span class="notification-item__title">{{ notification.title }}</span>
                  <span class="notification-item__message">{{ notification.message }}</span>
                  <span class="notification-item__time">{{ formatNotificationTime(notification.createdAt) }}</span>
                </span>
                @if (!notification.read) {
                  <span class="notification-item__dot"></span>
                }
              </button>
            }
          </div>
        } @else {
          <div class="notification-empty" (click)="$event.stopPropagation()">
            <mat-icon>notifications_none</mat-icon>
            <div>No notifications yet</div>
          </div>
        }

        <div class="notification-menu__footer" (click)="$event.stopPropagation()">
          <button mat-button color="primary" class="w-100" type="button" (click)="goToNotificationPage()">
            View all notifications
          </button>
        </div>
      </mat-menu>

      <!-- Profile -->
      <div class="profile-section">
        <div class="profile-identity">
          <span class="user-role">{{ userDisplayName || userRoleLabel }}</span>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="profileMenu">
          <img [src]="userProfileImage | defaultImage" (error)="onImageError($event)" class="profile-img" />
        </button>
      </div>

      <mat-menu #profileMenu="matMenu" class="profile-menu-panel">
        <div class="profile-menu-card">
          <div class="profile-menu-card__header">
            @if (userEmail) {
              <div class="profile-menu-card__subtitle">{{ userEmail }}</div>
            }
          </div>

          <div class="profile-menu-card__section">
            <div class="profile-menu-card__label">Primary Access</div>
            <div class="access-chip access-chip--primary">{{ userRoleLabel }}</div>
          </div>

          @if (userRoleLabels.length) {
            <div class="profile-menu-card__section">
              <div class="profile-menu-card__label">Additional Access</div>
              <div class="access-chip-list">
                @for (label of userRoleLabels; track label) {
                  <span class="access-chip">{{ label }}</span>
                }
              </div>
            </div>
          }

          <button mat-menu-item class="profile-menu-card__action" (click)="goToProfile()">
            <mat-icon>person</mat-icon>
            <span>My Profile</span>
          </button>

          @if (userRole === 'customer') {
            <button mat-menu-item class="profile-menu-card__action" (click)="goToSupport()">
              <mat-icon>support_agent</mat-icon>
              <span>Support Center</span>
            </button>
          }

          <div class="menu-footer p-t-10">
            <button mat-flat-button color="primary" class="w-100 profile-menu-card__logout" (click)="logout()">
              Logout
            </button>
          </div>
        </div>
      </mat-menu>

    } @else {
      <!-- Sign In / Sign Up -->
      <button mat-stroked-button color="primary" class="login" routerLink="/authentication/login">Sign In</button>
      <button mat-flat-button color="primary" class="register" routerLink="/authentication/register">Sign Up</button>
      
    }

  </div>
</div>
